import { combineReducers } from 'redux';
import * as NotesReqApprovalUI from '_reducers/notesReqApproval.ui.reducer';
import * as NotesPendingActionUI from '_reducers/notesPendingAction.ui.reducer';
import * as MessageCenterUI from '_reducers/messageCenter.ui.reducer';
import * as AlertReducer from '_reducers/alert.reducer';
import * as QuickSearchReducer from '_reducers/quickSearch.ui.reducer';
import * as SearchReducer from '_reducers/search.ui.reducer';
import * as PatientReducer from '_reducers/patients.ui.reducer';
import * as PatientTabsReducer from '_reducers/patientTabs.ui.reducer';
import * as PdfReducer from '_reducers/pdfs.ui.reducer';
import * as PatientCenterUI from '_reducers/patientCenter.ui.reducer';
import * as AdmissionsUI from '_reducers/admissions.ui.reducer';
import * as CdvUI from '_reducers/cdv.ui.reducer';
import * as CdvOptionsUI from '_reducers/cdvOptions.ui.reducer';
import * as DiaryUI from '_reducers/diary.ui.reducer';
import * as ApptHistUI from '_reducers/apptHist.ui.reducer';
import * as PeerReviewUI from '_reducers/peerReviews.ui.reducer';
import * as NotesUI from '_reducers/notes.ui.reducer';
import * as ScrollPos from '_reducers/scrollPos.ui.reducer';
import * as ErrorReportUI from '_reducers/errorReport.ui.reducer';
import * as AlUI from '_reducers/al.ui.reducer';
import * as DashboardUI from '_reducers/dashboard.ui.reducer';
import * as PNDueUI from '_reducers/pnDue.ui.reducer';
import * as DCDueUI from '_reducers/dcDue.ui.reducer';
import * as SpecProgUI from '_reducers/specProgReqMsgs.ui.reducer';
import * as FedRevUI from '_reducers/federalReviewMsgs.ui.reducer';
import * as MCDiaryUI from '_reducers/mcDiaryItems.ui.reducer';
import * as HelpCenterUI from '_reducers/helpCenter.ui.reducer';
import * as Route from '_reducers/route.ui.reducer';
import * as SessionUI from '_reducers/session.ui.reducer';
import * as CetsUI from '_reducers/cets.ui.reducer';
import * as RefreshUI from '_reducers/refresh.ui.reducer';


const reducers = {
    notesReqApproval: NotesReqApprovalUI.reducer,
    notesPendingAction: NotesPendingActionUI.reducer,
    messageCenter: MessageCenterUI.reducer,
    alert: AlertReducer.reducer,
    quickSearch: QuickSearchReducer.reducer,
    search: SearchReducer.reducer,
    patients: PatientReducer.reducer,
    patientTabs: PatientTabsReducer.reducer,
    pdfs: PdfReducer.reducer,
    patientCenter: PatientCenterUI.reducer,
    admissions: AdmissionsUI.reducer,
    cdv: CdvUI.reducer,
    cdvOptions: CdvOptionsUI.reducer,
    diary: DiaryUI.reducer,
    apptHist: ApptHistUI.reducer,
    peerReviews: PeerReviewUI.reducer,
    notes: NotesUI.reducer,
    scrollPos: ScrollPos.reducer,
    route: Route.reducer,
    errorReport: ErrorReportUI.reducer,
    al: AlUI.reducer,
    dashboard: DashboardUI.reducer,
    pnDue: PNDueUI.reducer,
    dcDue: DCDueUI.reducer,
    specProgReqMsgs: SpecProgUI.reducer,
    federalReviewMsgs: FedRevUI.reducer,
    mcDiaryItems: MCDiaryUI.reducer,
    helpCenter: HelpCenterUI.reducer,
    session: SessionUI.reducer,
    cets: CetsUI.reducer,
    refresh: RefreshUI.reducer,
};

export const reducer = combineReducers(reducers);